<template>
    <div>
        <div id="content" class="w">
            
            <!--cat over-->
            <!-- 产品列表 -->
            <public-shop-search-list></public-shop-search-list>
            <!-- 热门推荐 -->
            <public-shop-hot></public-shop-hot>
        </div>
        <!--content over-->
    </div>
</template>

<script>
import Public_shop_search_list from "./shopsearchlist.vue"
import Public_shop_hot from "./shophot.vue"
export default{
    components:{
        "public-shop-search-list" : Public_shop_search_list,
        "public-shop-hot" : Public_shop_hot
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shop/shopsearch/shopsearch.vue